import { Line } from "./styled";

export const BlackLine = () => <Line />;
